import { Link } from 'bricks-ui/packages/bricks-ui';

export default Link;
